"use client";

import { useCallback, useEffect, useState } from "react";
import {
  Grid,
  Card,
  CardHeader,
  CardContent,
  Box,
  Typography,
  Chip,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import FileUploadArea from "./common/FileUploadArea";
import DocumentCard from "./common/DocumentCard";
import { useDocuments } from "../../../../hooks/useDocuments";
import { useFileUploadMP } from "../../../../hooks/useUploadFileMP";
import { useLocation } from "react-router-dom";

import { DownloadFiles } from "../../../../../../services/DownloadFiles";
import { useToast } from "../../../../../../Hooks/UseToast";

const initialDocuments = [];

export default function GeneralOverviewTab() {
  const { equipo } = useLocation().state;
  const fileId = equipo.uuid_documentacion;

  const { uploadFile, isUploading, uploadProgress } = useFileUploadMP();
  const { removeDocument, getDocuments, documents, ViewFiles } =
    useDocuments(initialDocuments);
  const { showToast, Toast } = useToast();

  const refetchGeneralDocs = () => getDocuments(fileId, "general");

  useEffect(() => {
    if (fileId) refetchGeneralDocs();
  }, [fileId]);

  // 🔹 Subida de archivos
  const handleFileSelect = async (files) => {
    if (!fileId) {
      console.log("No hay ID de archivo");
      return;
    }

    try {
      const data = await uploadFile(files, "general", fileId);
      console.log("Archivo subido:", data);

      await refetchGeneralDocs();
      showToast("Archivo cargado con éxito", "success");
    } catch (err) {
      showToast("Error al subir archivo", "error");
    }
  };

  const handleDocumentDelete = async (doc) => {
    await removeDocument(doc.id, doc.nombre);
    await refetchGeneralDocs();
    showToast("Archivo eliminado", "info");
  };

  const handleDocumentView = (document) => {
    ViewFiles(document.id_archivo + "-" + document.nombre, document.extension);
    // Implementar lógica de vista previa
  };

  const handleDocumentDownload = (document) => {
    DownloadFiles(document.id_archivo + "-" + document.nombre);
    // Implementar lógica de descarga
  };
  /*   const handleFormChange = (field) => (event) => {
    setDocumentForm((prev) => ({
      ...prev,
      [field]: event.target.value,
    }));
  };
 */
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Card>
          <CardHeader
            title="Documentación Técnica General"
            subheader="Carga manuales de operación, protocolos de mantenimiento y documentación general del equipo"
          />
          <CardContent>
            <Box sx={{ mb: 4 }}>
              <FileUploadArea
                title="Cargar Documentación Técnica"
                description="Arrastra y suelta archivos aquí o haz clic para seleccionar"
                acceptedTypes=".pdf,.doc,.docx,.txt"
                onFileSelect={handleFileSelect}
                isUploading={isUploading}
                uploadProgress={uploadProgress}
              />
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <Typography variant="h6">Documentos Cargados</Typography>
              <Chip
                label={`${documents?.length} documentos`}
                variant="outlined"
              />
            </Box>

            {documents?.map((doc) => (
              <DocumentCard
                key={doc.id}
                document={doc}
                onView={handleDocumentView}
                onDownload={handleDocumentDownload}
                onDelete={handleDocumentDelete}
              />
            ))}
            {Toast}
            {/*  <Card sx={{ mt: 3, bgcolor: "grey.50" }}>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Agregar Información Adicional
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <FormControl fullWidth>
                      <InputLabel>Categoría</InputLabel>
                      <Select value={documentForm.category} onChange={handleFormChange("category")} label="Categoría">
                        {Object.entries(DOCUMENT_CATEGORY_LABELS).map(([key, label]) => (
                          <MenuItem key={key} value={key}>
                            {label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Versión"
                      placeholder="ej. v2.1"
                      value={documentForm.version}
                      onChange={handleFormChange("version")}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      multiline
                      rows={3}
                      label="Descripción"
                      placeholder="Descripción del documento..."
                      value={documentForm.description}
                      onChange={handleFormChange("description")}
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card> */}
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}
